/**
 * @generated SignedSource<<2a73a778eb7a9a8ad5dad5b36a57f590>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type genericArticleSpeechInlineWidgetGenericArticle$data = {
  readonly articleSpeeches: ReadonlyArray<{
    readonly url: string;
  } | null | undefined> | null | undefined;
  readonly entityId: string;
  readonly " $fragmentSpreads": FragmentRefs<"buttonArticleSpeechInlineWidgetGenericButtonArticle" | "hooksShowGenericInlineWidgetByArticleArticle" | "toolTipArticleSpeechWidgetToolTipArticle">;
  readonly " $fragmentType": "genericArticleSpeechInlineWidgetGenericArticle";
};
export type genericArticleSpeechInlineWidgetGenericArticle$key = {
  readonly " $data"?: genericArticleSpeechInlineWidgetGenericArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"genericArticleSpeechInlineWidgetGenericArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "genericArticleSpeechInlineWidgetGenericArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ArticleSpeech",
      "kind": "LinkedField",
      "name": "articleSpeeches",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "buttonArticleSpeechInlineWidgetGenericButtonArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "hooksShowGenericInlineWidgetByArticleArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "toolTipArticleSpeechWidgetToolTipArticle"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "84cfd9741ff439d4da1e85039815b6d0";

export default node;
